import { useRef, useState } from 'react';
import {
  getSaleFrameSrc,
  getLeaseFrameSrc,
} from '../../helpers/quokka_template_defaults_editor/templates_data_helpers';
import useOptionsEditorCfgNotifier from './use_options_editor_cfg_notifier';
import useTemplatesData from './use_templates_data';

// Returns the properties to control the editor modal and the nested iframe
//
// The ref passed in the quokkaIframeData has to be passed
// to the iframe that will contain quokka.
// In this way, the iframe will be set up to do the communication between
// both systems.
const useEditorModal = (initialTemplatesData) => {
  const quokkaIframeRef = useRef();

  const [templateId, setTemplateId] = useState();
  const [open, setOpen] = useState(false);
  const [frameSrc, setFrameSrc] = useState(getSaleFrameSrc(templatesData, templateId));
  const [propertyType, setPropertyType] = useState('sale');

  const templatesData = useTemplatesData(initialTemplatesData, propertyType);

  useOptionsEditorCfgNotifier(templateId, templatesData, quokkaIframeRef, propertyType);

  const setTemplateToEditId = (templateId) => {
    setTemplateId(templateId);
    setOpen(true);
  };

  const onClose = () => {
    // This is needed to force a change in templateId when closing and
    // opening the modal for the same templateId
    // See useOptionsEditorCfgNotifier for more details.
    setTemplateId(null);

    setOpen(false);
  };

  const saleFrameSrc = getSaleFrameSrc(templatesData, templateId);
  const leaseFrameSrc = getLeaseFrameSrc(templatesData, templateId);

  const saleQuokkaIframeData = saleFrameSrc && { ref: quokkaIframeRef, src: saleFrameSrc };
  const leaseQuokkaIframeData = leaseFrameSrc && { ref: quokkaIframeRef, src: leaseFrameSrc };
  const quokkaIframeData = frameSrc === saleFrameSrc ? saleQuokkaIframeData : leaseQuokkaIframeData;

  const refreshQuokkaData = (propertyType) => {
    if (propertyType === 'sale') {
      setFrameSrc(saleFrameSrc);
    } else if (propertyType === 'lease') {
      setFrameSrc(leaseFrameSrc);
    }

    setPropertyType(propertyType);
  };

  return {
    open: open,
    onClose,
    quokkaIframeData, // May be null
    refreshQuokkaData,
    setTemplateToEditId
  };
};

export default useEditorModal;

